import { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";
import { Output } from "valibot";

import { ChatDataSchema } from "components/SonicBot/schemas";
import { getActiveCampaignFields } from "shared/api";
import { ReactComponent as IconClose } from "assets/images/icons/close-black.svg";

type Props = {
  chatbotColor: string;
  chatData: Output<typeof ChatDataSchema>;
  integrationLink: string;
  activeCampaignUserEmail: string | undefined;
  token: string;
  setIntegrationLink: React.Dispatch<React.SetStateAction<string | null>>;
};

function IntegrationInlineWidget(props: Props) {
  const {
    chatbotColor,
    chatData,
    integrationLink,
    activeCampaignUserEmail,
    setIntegrationLink,
    token,
  } = props;

  const [email, setEmail] = useState<string | undefined>();
  const [name, setName] = useState<string | undefined>();
  const [activeCampaignDataLoaded, setActiveCampaignDataLoaded] =
    useState<boolean>(false);

  useEffect(() => {
    if (!activeCampaignUserEmail) {
      return;
    }
    getActiveCampaignFields({
      email: activeCampaignUserEmail,
      token,
    }).then(
      user => {
        if (user) {
          setEmail(user.email || activeCampaignUserEmail);
          setName(user.first_name + " " + user.last_name);
          setActiveCampaignDataLoaded(true);
        }
      },
      err => {
        setActiveCampaignDataLoaded(false);
      },
    );
  }, [activeCampaignUserEmail, token]);

  const dataLoaded = activeCampaignUserEmail ? activeCampaignDataLoaded : true;

  return (
    <div className="relative">
      {/* Calendly inline widget begin */}
      {dataLoaded && (
        <InlineWidget
          url={integrationLink}
          styles={{
            height: "86vh",
          }}
          pageSettings={{
            hideEventTypeDetails: true,
            hideLandingPageDetails: true,
            hideGdprBanner: true,
          }}
          prefill={{
            email,
            name,
          }}
          iframeTitle={"Botsonic Calendly Meeting Scheduler"}
        />
      )}
      {!dataLoaded && <p className="py-32 text-center">Loading...</p>}
      {/* Calendly inline widget end */}
      <button
        onClick={() => {
          setIntegrationLink(null);
          chatData.push({
            message: `You've cancelled the meeting.`,
            sent: false,
          });
        }}
        className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-white outline-none"
        style={{ backgroundColor: chatbotColor }}
        data-tip="Close"
      >
        <IconClose />
      </button>
    </div>
  );
}

export default IntegrationInlineWidget;
